import * as React from 'react';
import { useState } from 'react';
import { Card, Grid, Header1Text, PageLoading, TextInput } from 'ui-toolkit';
import { ClientsTable } from '../../components/clients/ClientsTable';
import { useListClientsQuery } from '../../API/clients/ClientCompanyApi';
import { ErrorMessageTW } from '../../tailwindComponents/errorMessage/ErrorMessageTW';
import { IClientCompanyData } from '../../ui-toolkit/orders/interfaces/IClient';

export const ClientCompaniesTab: React.FC = () => {
  const {
    data: allClients = [],
    isLoading: isLenderCompanyLoading,
    error: fetchError,
  } = useListClientsQuery({ includeDeactivated: true });
  const [filter, setFilter] = useState<string | null>(null);

  const filteredCompanies = allClients.filter((company: IClientCompanyData) =>
    filter ? company?.name?.toLowerCase().includes(filter.toLowerCase()) : true
  );

  return (
    <>
      {isLenderCompanyLoading ? (
        <PageLoading isLoading={true} />
      ) : (
        <Grid data-test-id={'clients-table'}>
          <Header1Text>Clients</Header1Text>
          <Grid columnCount={2}>
            <TextInput value={filter} placeholder={'Search'} onChange={setFilter} />
          </Grid>
          <ErrorMessageTW rtkError={fetchError} />
          <Card>
            <ClientsTable data={filteredCompanies} />
          </Card>
        </Grid>
      )}
    </>
  );
};
